module.exports = __webpack_public_path__ + "static/media/logo_small.724d180f.svg";